import { c as _c } from "react/compiler-runtime";
import { cn } from "cn";
import type * as React from "react";
type MenuIconProps = React.ComponentProps<"svg">;
function MenuIcon(t0) {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-4", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M4 5h16" />;
    t3 = <path d="M4 12h16" />;
    t4 = <path d="M4 19h16" />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t1) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={t1} {...props}>{t2}{t3}{t4}</svg>;
    $[8] = props;
    $[9] = t1;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export { MenuIcon, type MenuIconProps };